export default __webpack_public_path__ + "static/media/sandwich.c6a21342.svg";